<div class="common-modal__container">
  <div class="common-modal__header">
    <span class="common-modal__text-header common-modal__text-header-flex-none">
      {{processModal.process.title}}
    </span>
    @if(processModal.process.description){
      <button class="common-button__icon-sm-background"
        (click)="processReferencesView()">
        <i class="lf-icon-information common-icon__md"></i>
      </button>
    }
  </div>


  @if (processModal.isConceptObject && !processModal.view) {
    <div class="process-modal__top-buttons-container" >
      <div class="common-button__body-icon-set-sm">
        <button class="common-button__icon-md-border"
          pTooltip="{{'expanded-menu.add-alert' | afTranslate}}"
          tooltipPosition="bottom"
          (click)="addAlertModal()">
          <i class="lf-icon-notification common-icon__md"></i>
        </button>
        <button-with-menu-action
          [item]="processModal.newDocument"
          [icon]="'lf-icon-document-new'"
          [multiline]="1"
          [buttonClass]="'common-button__icon-md-border'"
          (launchActionEmitter)="selectOption($event.action)">
        </button-with-menu-action>
        <button class="common-button__icon-md-border"
          pTooltip="{{'common.export-process' | afTranslate}}"
          tooltipPosition="bottom"
          (click)="exportProcess()">
          <i class="lf-icon-send common-icon__md"></i>
        </button>
      </div>
    </div>
  }
  <div class="process-modal__diagramacion-zone-container">
    <rappid [component]="processModal.rappid"
      [model]="processModal.model"
      [canAddAlerts]="processModal.canAddAlerts"
      [from]="'view'"
      (onAction)="onCellAction($event)"
      [hideDates]="configuration?.hideDates"
      id="rappid-process-modal">
    </rappid>
  </div>
  <!-- @if (processModal.view === 'next') {
    <div
      class="process-modal__next__layer">
      <h2 class="common__underlined-title">
        <i class="lf-icon-arrow-round-right"></i>
        <span [afTranslate]="'process.modal.forward-title1'"></span>
        <span class="common__underlined-title--smaller" [afTranslate]="'process.modal.forward-title2'"></span>
      </h2>
      <div class="process-modal__next__fields">
        <field-type-list-simple [field]="processModal.nextStateFieldInfo"
          [listValues]="processModal.nextStateFieldList"
          [preSelectItem]="processModal.nextStateSelected"
          (itemSelected)="processModal.nextStateSelected = $event.newValue;">
        </field-type-list-simple>
      </div>
    </div>
  } -->
  <div class="common-modal__footer-container">
    @if (processModal.isConceptObject && !processModal.view) {
      <div class="common-pagination__container-next-prev">
        <button class="common-button__text-noborder"
          [ngClass]="{'common-button__text-noborder--disabled':!processModal.lastTransition || !configuration.canChangeState}"
          (click)="nextOrBack('back')"
          [disabled]="!processModal.lastTransition || !configuration.canChangeState">
          <i class="lf-icon-angle-left common-icon__md"></i>
          <span class="common-button__text-little-title"
            [afTranslate]="'common.go-back'">_Retroceder</span>
        </button>
        <button class="common-button__text-noborder"
          [ngClass]="{'common-button__text-noborder--disabled':!processModal.nextTransitions || !configuration.canChangeState}"
          (click)="nextOrBack('next')"
          [disabled]="!processModal.nextTransitions || !configuration.canChangeState">
          <span class="common-button__text-little-title"
            [afTranslate]="'common.advance'">_Avanzar</span>
          <i class="lf-icon-angle-right common-icon__md"></i>
        </button>
      </div>
    }
    <div class="common-modal__footer  process-modal__footer">
      <button class="common-button__text"
        (click)="handleDismiss()">
        <span class="common-button__text-title"
          [afTranslate]="'common.close'">_cerrar</span>
      </button>
    </div>
  </div>
</div>
@if(processModal.exportDate){
  <div class="common__pdf-hidde-element">
  <div class="common__pdf-block-view"
    id="pdf-process-modal">
    <pdf-header
        [datePdf]="processModal.exportDate">
    </pdf-header>
    <div class="common__pdf-body">
        <div class="common__pdf-title-block">
            <span [ngShow]="processModal.config.concept.titlePrefix !== null">{{processModal.config.concept.titlePrefix}} / </span>
            <span>{{processModal.config.concept.title}}</span>
        </div>
        <div class="common__pdf-subtitle-block">
            <span [afTranslate]="'process.modal.process-management'">_Gestión del proceso</span>
        </div>
        <div class="process-modal__pdf-body">
            <div class="process-modal__pdf-inner-body">
                <div id="rappid-pdf"></div>
            </div>
        </div>
    </div>
  </div>
</div>

}
